module.exports = __webpack_public_path__ + "media/images/SWIFT_whitelogo-b7a086a72a6756f9dc35a62d8c3d5991.png";